import React, { useEffect } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { usePlace } from '../../nucleus/place';
import { shownAddress } from '../../nucleus/map';
import ProfilePage from './ProfilePage';
import NotificationsPage from './NotificationsPage';
import SecurityPage from './SecurityPage';
import DataPage from './DataPage';
import PublicPage from './PublicPage';
import GroupSettingsPage from './GroupSettingsPage';
import SharePage from './SharePage';
import AppearancePage from './AppearancePage';
import './SelfSection.css';

// SELF — step 01 of the map: who you are here. A person's profile and
// identities, notifications, security (session, timezone, recovery codes, where
// you are signed in), data in bulk and the public page; in a group, the group's
// identities, its settings, your share into it, its data and its public page.
//
// Mostly settings: each page's body is a column of bands (selfForm.js), and
// only the collections — identities, sessions — open in the inspector.
const PAGES = {
    appearance: AppearancePage,
    profile: ProfilePage,
    notifications: NotificationsPage,
    security: SecurityPage,
    data: DataPage,
    public: PublicPage,
    settings: GroupSettingsPage,
    share: SharePage,
};

export default function SelfSection() {
    const { page, groupId } = usePlace();
    const [params, setParams] = useSearchParams();

    // The old ?identity=<id> (realm and relationship pages) opens that identity.
    const asked = params.get('identity');
    useEffect(() => {
        if (!asked) return;
        setParams((p) => {
            const n = new URLSearchParams(p);
            n.delete('identity');
            if (!n.get('open')) n.set('open', asked);
            return n;
        }, { replace: true });
    }, [asked, setParams]);

    // your own public page moved to People (a group's stays here)
    const { pathname, search } = useLocation();
    if (!groupId && /\/self\/public\/?$/.test(pathname)) return <Navigate replace to={`/people/public${search}`} />;
    // a page Settings does not have here: the address says the page it shows
    const shown = shownAddress(pathname);
    if (shown) return <Navigate replace to={`${shown}${search}`} />;

    const Page = PAGES[page?.id] || ProfilePage;
    return (
        <Page key={`${page?.id}:${groupId || 'personal'}`} />
    );
}
